<div class="lifeCycle-wrapper">
  <mat-card class="info-card">
    <div class="cycle-content">
      <div class="title">Turns monitoring</div>
      <div class="desc">
        Turn Monitoring allows you to track the turns of your component. You can view the current turn count for each
        component and set the equipment to “In service" or “Release it”. This information can help you optimize the
        usage and maintenance of your transport equipment."
      </div>
      <div class="table-scroll" role="region" aria-label="Turns history" tabindex="0">
        <table>
          <tr class="border-bottom-2">
            <th style="width: 5%">Turns</th>
            <th style="width: 10%">Start date</th>
            <th style="width: 10%">End date</th>
            <th style="width: 75%">Journey</th>
          </tr>
          @if (isLoaded) { @for (c of cycles; track c; let i = $index) {
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ c.startDate }}</td>
            <td>{{ i === cycles.length - 1 ? "" : c.endDate }}</td>
            <td class="flex-space-between">
              @for (journey of c.journey; track journey; let i = $index) {
              <div
                [ngClass]="i !== c.journey.length - 1 ? 'container' : 'align-center'"
                style.width="calc({{
                  calculateJourneyWidth(journey.endDate, journey.startDate, c.totalCycleDays)
                }}% + 50px)"
              >
                <svg-icon
                  [matTooltipDisabled]="!journey.showTooltip"
                  matTooltip="{{ displayTooltipText(journey) }}"
                  matTooltipClass="journeyTooltip"
                  [matTooltipPosition]="'below'"
                  [svgStyle]="{ 'padding-right.px': 8, 'padding-left.px': 8 }"
                  src="{{ getJourneyIcon(journey.type) }}"
                ></svg-icon>
                <div class="line"><mat-divider></mat-divider></div>
              </div>
              } @if (!c.isCompleted && c.journey.length > 1) {
              <button class="service-button receive" mat-raised-button (click)="setStateToReceived()">
                <svg-icon
                  [svgStyle]="{ 'width.px': 32, 'height.px': 32, 'margin-right.px': 4 }"
                  src="/assets/icons/journey/service.svg"
                ></svg-icon>
                Receive
              </button>
              } @if (c.isCompleted && c.journey.length === 1) {
              <button class="service-button release" mat-raised-button (click)="setStateToReleasedFromService()">
                <svg-icon
                  [svgStyle]="{ 'width.px': 32, 'height.px': 32, 'margin-right.px': 4 }"
                  src="/assets/icons/journey/active.svg"
                ></svg-icon>
                Release
              </button>
              }
            </td>
          </tr>
          } }
        </table>
      </div>
      @if (!isLoaded) {
      <div class="center-item text-empty-label">loading life turns .....</div>
      }
    </div>
  </mat-card>
</div>
